<ng-container *ngIf="position && formatType && partners?.length" class="section pt-0">
    <div [ngClass]="'col-12 d-flex justify-content-center p-' + padding">
        <ngb-carousel
            [ngStyle]="{ width: fullWidth ? '100%' : widthCarousel + 'px', height: heightCarousel + 'px' }"
            [showNavigationIndicators]="false"
            [showNavigationArrows]="false"
            [interval]="3000"
        >
            <ng-template ngbSlide *ngFor="let group of partnersGroups">
                <ng-container
                    *ngFor="
                        let partner of partners
                            | slice
                                : group * partnersPerGroup
                                : (group === partnersGroups.length - 1
                                      ? partners.length
                                      : group * partnersPerGroup + partnersPerGroup);
                        let i = index
                    "
                >
                    <div
                        class="partner"
                        *ngIf="partner?.url_redirect; else noLinkTemplate"
                        [ngStyle]="{ width: widthPartner + 'px', height: heightPartner + 'px', 'max-width': '100%' }"
                    >
                        <a [href]="partner.url_redirect" target="_blank" rel="noopener noreferrer">
                            <img [src]="partner.url_banner || partner.url_logo" />
                        </a>
                    </div>
                    <ng-template #noLinkTemplate>
                        <div *ngIf="partner?.url_banner || partner?.url_logo" class="partner">
                            <img [src]="partner.url_banner || partner.url_logo" />
                        </div>
                    </ng-template>
                </ng-container>
            </ng-template>
        </ngb-carousel>
    </div>
</ng-container>
